import React from 'react';
import { Checkbox } from 'antd';
import { FormMode } from '../../../views/account/admin/common/types/AccountAdminFormType';

interface IIndeterminateCheckBoxProps {
  indeterminate?: boolean;
  mode?: string;
  rowKey: string;
}

const IndeterminateCheckBox: React.FC<IIndeterminateCheckBoxProps> = ({ indeterminate, mode, rowKey, ...rest }) => {
  return (
    <div data-testid={`checkbox-${rowKey}`}>
      <Checkbox indeterminate={indeterminate} disabled={mode === FormMode.DETAIL} {...rest} />
    </div>
  );
};

export default IndeterminateCheckBox;
